import { render, staticRenderFns } from "./BusinessProgramPriceChanges.vue?vue&type=template&id=47954193"
import script from "./BusinessProgramPriceChanges.vue?vue&type=script&lang=js"
export * from "./BusinessProgramPriceChanges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports